module.exports = __webpack_public_path__ + "img/easttimor.f97b6d7c.svg";